exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.itr_slider .v-slider__track__container {\n  height: 8px;\n}\n.itr_slider .v-slider__thumb {\n  width: 36px;\n  height: 36px;\n  background: black;\n}\n.v-slider__track,\n.v-slider__track-fill {\n  height: 8px;\n}\n.itr_slider .theme--light.v-input--slider .v-slider__ticks {\n  border-color: #c8cbd0;\n  -webkit-box-shadow: 1px 2px 7px rgba(2, 73, 140, 0.12);\n          box-shadow: 1px 2px 7px rgba(2, 73, 140, 0.12);\n  -webkit-transform: matrix(-1, 0, 0, 1, 0, 0);\n          transform: matrix(-1, 0, 0, 1, 0, 0);\n}\n", ""]);

// exports
